import chmln from '@chamaeleonidae/chmln'
import type {User} from '~/types'

export type Chmln = {
  init: typeof chmln.init
  identify: typeof chmln.identify
  track: typeof chmln.track
}

declare global {
  interface Window {
    chmln: Chmln | undefined
  }
}

/**
 * Initialize Chameleon analytics tracking if window.chmln is not defined
 * @param chameleonAppId - The Chameleon app ID
 */
export const initChameleon = (chameleonAppId: string) => {
  try {
    if (typeof window === 'undefined' || window.chmln) {
      return
    }
    chmln.init(chameleonAppId)
  } catch (error) {
    console.warn('Failed to initialize Chameleon:', error)
  }
}

/**
 * Connect user identity to Chameleon analytics tracking
 * @param userData - The user's data fetched from backend
 */
export const setUpChameleon = (userData: User) => {
  try {
    if (typeof chmln?.identify === 'function') {
      chmln.identify(userData.user_uuid, {
        email: userData.email,
        name: userData.name,
      })
    }
  } catch (error) {
    console.warn('Failed to setup Chameleon user:', error)
  }
}
